import React, { useState, useEffect } from 'react';
import { API } from '../services/apiConfig';

function UserDashboard({ onLogout }) {
  const [products, setProducts] = useState([]);
  const [groupedProducts, setGroupedProducts] = useState({});

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await fetch(`${API}/api/products`);
      const data = await response.json();
      console.log('Products:', data);
      
      // Convert absolute paths to relative URLs
      const productsWithFixedImages = data.map(p => ({
        ...p,
        images: p.images?.map(img => {
          if (img.includes('\\')) {
            const parts = img.split('\\');
            const filename = parts[parts.length - 1];
            return `${API}/images/${filename}`;
          }
          return img;
        })
      }));
      
      console.log('Fixed images:', productsWithFixedImages);
      
      setProducts(productsWithFixedImages);
      
      const grouped = productsWithFixedImages.reduce((acc, product) => {
        const category = product.category || 'UNCATEGORIZED';
        if (!acc[category]) acc[category] = [];
        acc[category].push(product);
        return acc;
      }, {});
      setGroupedProducts(grouped);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
        <h1>User Dashboard</h1>
        <button onClick={onLogout} style={{ padding: '10px 20px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Logout</button>
      </div>
      
      {Object.keys(groupedProducts).length === 0 ? (
        <p>No products available.</p>
      ) : (
        Object.keys(groupedProducts).map(category => (
          <div key={category} style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', borderBottom: '2px solid #667eea', paddingBottom: '10px' }}>{category}</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', marginTop: '20px' }}>
              {groupedProducts[category].map(product => (
                <div key={product.id} style={{ border: '1px solid #ddd', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                  {product.images && product.images.length > 0 && (
                    <img src={product.images[0]} alt={product.name} style={{ width: '100%', height: 'auto', borderRadius: '4px', marginBottom: '10px' }} onError={(e) => e.target.style.display = 'none'} />
                  )}
                  <h3 style={{ color: '#333', marginBottom: '10px' }}>{product.name}</h3>
                  <p style={{ color: '#666', fontSize: '14px', marginBottom: '10px' }}>{product.description}</p>
                  {product.details && (
                    <p style={{ color: '#888', fontSize: '12px', marginBottom: '10px' }}>{product.details}</p>
                  )}
                  {product.specifications && Object.keys(product.specifications).length > 0 && (
                    <div style={{ marginBottom: '10px', fontSize: '12px' }}>
                      {Object.entries(product.specifications).map(([key, value]) => (
                        <div key={key}><strong>{key}:</strong> {value}</div>
                      ))}
                    </div>
                  )}
                  <p style={{ fontWeight: 'bold', fontSize: '18px', color: '#28a745', marginBottom: '15px' }}>${product.price}</p>
                  <button style={{ width: '100%', padding: '10px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                    Add to Cart
                  </button>
                </div>
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default UserDashboard;
